import parse from 'html-react-parser';
import type React from 'react';
import { type ReactElement, useRef, useState } from 'react';
import { generate } from 'short-uuid';

interface IProps {
  children: ReactElement; // Type children better since OverlayTrigger only accepts ReactElement but type of FC is ReactNode
  id?: string;
  text: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
  arrowClassName?: string;
  parentClassName?: string;
  isHtmlText?: boolean;
}

const tooltipClassNames = {
  bottom: 'transform -translate-x-1/2 left-1/2 top-6 mt-1',
  top: 'transform -translate-x-1/2 left-1/2 bottom-6 mb-1',
  left: 'right-8 transform -translate-y-1/2 top-1/2 m-0',
  right: 'left-8 transform -translate-y-1/2 top-1/2 m-0',
};

const arrowClassNames = {
  bottom: 'rotate-45 top-[-9px] left-1/2 -translate-x-1/2 translate-y-1/2',
  top: 'rotate-45 bottom-[-9px] left-1/2 -translate-x-1/2 -translate-y-1/2',
  left: 'rotate-45 right-[-3px] top-1/2 -translate-y-1/2',
  right: 'rotate-45 left-[-3px] top-1/2 -translate-y-1/2',
};

export const GeneralTooltip: React.FC<IProps> = ({
  children,
  text,
  placement = 'bottom',
  id = generate(),
  className,
  arrowClassName,
  parentClassName = '',
  isHtmlText = false,
}) => {
  const [show, setShow] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  // Only parse HTML when explicitly needed
  const renderText = () => {
    if (isHtmlText) {
      return parse(text);
    }
    return text;
  };

  return (
    <div
      ref={wrapperRef}
      className={`relative ${parentClassName}`}
      onMouseEnter={() => text?.trim() && setShow(true)}
      onMouseLeave={() => setShow(false)}>
      {children}
      {show && (
        <div
          id={id}
          className={`${
            className || ''
          } absolute z-[999] px-2 py-1 text-pico text-white bg-black rounded-md w-max ${
            tooltipClassNames[placement]
          }`}>
          <span className='relative z-[999] word-break-style'>
            {renderText()}
          </span>
          <div
            className={`absolute w-3 h-3 bg-black transform ${arrowClassNames[placement]} ${arrowClassName}`}
          />
        </div>
      )}
    </div>
  );
};
